import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

const AcatFrame = ({ acatAppUrl, authToken, lastPage }) => {
  const [iframeElement, setIframeElement] = useState(undefined);
  const [iframeHeight, setIframeHeight] = useState('120%');
  useEffect(() => {
    window.onmessage = ('message', (event) => {
      const message = JSON.stringify(event.data);
      if (message && message.includes('messageType')) {
        const eventData = JSON.parse(event.data);
        if (eventData.messageType === 'ready') {
          postDataToAcatIframe();
        }
        if (eventData.messageType === 'resize') {
          setIframeHeight(eventData.height);
        }
        if (eventData.messageType === 'routeChange') {
          setIframeHeight('120%');
        }
      }
    });
    const iframe = document.getElementById('acatFrame');
    setIframeElement(iframe);
    iframe.src = acatAppUrl;
    return () => {
      if (!iframeElement) return;
      iframeElement.removeEventListener('ready');
    };
  }, []);

  function postDataToAcatIframe() {
    const data = { accessToken: authToken, parentApp: 'ellis-app' };
    const iframe = document.getElementById('acatFrame');
    if (iframe) {
      const iframeDocument =
        iframe.contentWindow ||
        iframe.contentDocument ||
        iframe.contentDocument;
      iframeDocument.postMessage(data, '*');
    }
  }

  const acatFrameClass = lastPage ? 'acatFrameLastPage' : 'acatFrame';

  return (
    <div>
      <div
        id="acat-frame-container"
        className="col col-md-12 col-lg-10 h-full col-lg-offset-1 text-center"
      >
        {authToken && (
          <iframe
            id="acatFrame"
            className={acatFrameClass}
            title="Acat iFrame"
            width="100%"
            height={iframeHeight}
          />
        )}
      </div>
    </div>
  );
};

AcatFrame.propTypes = {
  acatAppUrl: PropTypes.string.isRequired,
  authToken: PropTypes.string.isRequired,
  lastPage: PropTypes.bool,
};

export default AcatFrame;
